import React, { useEffect, useState } from "react";
import { Segmented, Card } from "antd";
import "./ChatAndActivityTabs.css";
import ChatMsgPad from "../chat-communication/ChatMsgPad";
import { useDispatch, useSelector } from "react-redux";
import {
  markProductAsRead,
  setIsbuyerChatHistory,
} from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { getChatHistory } from "../../../store/thunks/common-thunks/commonThunk";
import { clearLiveMsgNotificationForProduct } from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";

const ChatAndActivitySegment = ({ senderName }) => {
  const [selectedSection, setSelectedSection] = useState("Chat");
  const { userId } = useSelector((state) => state.login);
  const { isProductInfo, campaignInfoForChat, isChatModal } = useSelector(
    (state) => state.chatCommunicationHandleSlice
  );
  const { buyerProductsChatHistory } = useSelector(
    (state) => state.chatHistory
  );
  const dispatch = useDispatch();
  const { isLiveMsgNotification } = useSelector((state) => state.webSocketMsgs);

  // Update buyer chat history when product info or chat history changes
  useEffect(() => {
    if (!buyerProductsChatHistory?.length || !isProductInfo?.product_id) return;

    const chatHistory = buyerProductsChatHistory.find(
      (item) =>
        String(item?.productId) === String(isProductInfo?.product_id) &&
        String(item?.bookingId) === String(isProductInfo?.id)
    );

    dispatch(setIsbuyerChatHistory(chatHistory ? { ...chatHistory } : null));
  }, [buyerProductsChatHistory, isProductInfo?.id]);
  useEffect(() => {
    if (!isProductInfo?.id || !campaignInfoForChat?.id) return;

    const campaignId = String(campaignInfoForChat?.id);
    const bookingId = String(isProductInfo?.id);

    const hasActiveLiveMsg = isLiveMsgNotification.some(
      (msg) =>
        String(msg.campaignId) === campaignId &&
        String(msg.bookingId) === bookingId
    );

    if (!hasActiveLiveMsg || !isChatModal) return;
    // 1️⃣ mark as read
    dispatch(
      markProductAsRead({
        campaignId,
        productId: bookingId,
        readAt: Date.now(),
      })
    );

    // 2️⃣ remove from live notifications
    dispatch(
      clearLiveMsgNotificationForProduct({
        campaignId,
        productId: bookingId,
      })
    );
  }, [
    isLiveMsgNotification,
    isProductInfo?.id,
    campaignInfoForChat?.id,
    dispatch,
  ]);
  return (
    <div className="chat-activity-container">
      <Card className="chat-activity-container-card">
        {/* Segmented Control */}
        <Segmented
          options={["Chat"]}
          value={selectedSection}
          onChange={setSelectedSection}
          block
          style={{ marginBottom: 16 }}
        />

        {/* Chat Section */}
        {selectedSection === "Chat" && (
          <>
            <ChatMsgPad
              key={`${isProductInfo?.id}-${isProductInfo?.product_id}`}
              senderName
              bookingId={isProductInfo?.id}
              productId={isProductInfo?.product_id}
              campaignId={campaignInfoForChat?.id}
              currentUserId={userId}
              receiverUserId={isProductInfo?.client_mongo_id}
              // chatHistory={isBuyerChatHistory?.chatHistory}
              isProductInfo={isProductInfo}
            />
          </>
        )}

        {/* Activity Log Section */}
        {selectedSection === "Activity Log" && (
          <div
            style={{
              borderRadius: "8px",
              padding: "16px",
              height: 350,
              overflowY: "auto",
            }}
          >
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              <li>User logged in</li>
              <li>Viewed product details</li>
              <li>Sent a message</li>
              <li>Logged out</li>
            </ul>
          </div>
        )}
      </Card>
    </div>
  );
};

export default ChatAndActivitySegment;
